import { authFetch } from "../utils/authFetch"
import { API_BASE_URL } from "../config"

// La URL base ahora apunta a la de producción cambio minimo
const baseUrl = `${API_BASE_URL}/membresia`

/**
 * --- MODIFICADO ---
 * Obtiene la lista de membresías para una sucursal específica.
 * @param {string | number} idSucursal - El ID de la sucursal.
 */
export const getMembresiasBySucursal = async (idSucursal) => {
  // Validamos que el idSucursal se haya proporcionado
  if (!idSucursal) {
    throw new Error("El ID de la sucursal es requerido para consultar las membresías.")
  }

  const response = await authFetch(`${baseUrl}/sucursal/${idSucursal}`, {
    method: "GET",
  })

  if (!response.ok) {
    // Si la respuesta es 404 (Not Found), devolvemos un array vacío,
    // ya que significa que la sucursal no tiene membresías aún.
    if (response.status === 404) {
      return []
    }
    const errorText = await response.text()
    throw new Error(`Error al consultar las membresías por sucursal: ${errorText || "Sin detalles"}`)
  }
  return response.json()
}

/**
 * --- SIN CAMBIOS ---
 * Obtiene la lista de TODAS las membresías (se puede mantener por si se necesita en otro lado).
 */
export const getMembresias = async () => {
  const response = await authFetch(`${baseUrl}/listar`, {
    method: "GET",
  })
  if (!response.ok) {
    const errorText = await response.text()
    throw new Error(`Error al consultar las membresías: ${errorText || "Sin detalles"}`)
  }
  return response.json()
}

/**
 * Obtiene la lista de ingresos de membresía para una sucursal específica.
 * @param {string | number} idSucursal - El ID de la sucursal.
 */
export const getIngresosMembresiasBySucursal = async (idSucursal) => {
  // Validamos que el idSucursal se haya proporcionado
  if (!idSucursal) {
    throw new Error("El ID de la sucursal es requerido para consultar los ingresos de membresías.")
  }

  const response = await authFetch(`${API_BASE_URL}/ingreso_membresia/sucursal/${idSucursal}`, {
    method: "GET",
  })

  if (!response.ok) {
    // Si la respuesta es 404 (Not Found), devolvemos un array vacío,
    // ya que significa que la sucursal no tiene ingresos aún.
    if (response.status === 404) {
      return []
    }
    const errorText = await response.text()
    throw new Error(`Error al consultar los ingresos de membresías por sucursal: ${errorText || "Sin detalles"}`)
  }
  return response.json()
}

/**
 * Crea una nueva membresía.
 * --- CÓDIGO CORREGIDO ---
 * Ahora maneja respuestas que no son JSON.
 */
export const createMembresia = async (membresiaData) => {
  const response = await authFetch(`${baseUrl}/crear`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(membresiaData),
  })

  if (!response.ok) {
    const errorText = await response.text()
    throw new Error(`Error al crear la membresía: ${errorText || "Sin detalles"}`)
  }

  // Verificamos el tipo de contenido de la respuesta para evitar el error de JSON
  const contentType = response.headers.get("Content-Type")
  if (contentType && contentType.includes("application/json")) {
    return response.json() // Si es JSON, lo procesamos
  } else {
    // Si es texto plano (como "Se creo..."), asumimos que fue exitoso
    return { success: true }
  }
}

/**
 * Actualiza una membresía existente.
 */
export const updateMembresia = async (idMembresia, formData) => {
  const bodyPayload = {
    cliente: { id: Number.parseInt(formData.clienteId, 10) },
    sucursal: { id: Number.parseInt(formData.sucursalId, 10) },
    fechaInicio: formData.fechaInicio,
    fechaFin: formData.fechaFin,
    monto: Number.parseFloat(formData.monto),
    idTipoTarifa: Number.parseInt(formData.idTipoTarifa, 10),
    activa: formData.activa,
  }

  const response = await authFetch(`${baseUrl}/modificar/${idMembresia}`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(bodyPayload),
  })

  if (!response.ok) {
    const errorText = await response.text()
    throw new Error(`Error al actualizar la membresía: ${errorText || "Sin detalles"}`)
  }

  if (response.status === 204 || response.headers.get("Content-Length") === "0") {
    return { success: true }
  }

  const contentType = response.headers.get("Content-Type")
  if (contentType && contentType.includes("application/json")) {
    return response.json()
  } else {
    return { success: true }
  }
}

/**
 * Elimina una membresía.
 */
export const deleteMembresia = async (id) => {
  const response = await authFetch(`${baseUrl}/eliminar/${id}`, {
    method: "DELETE",
  })
  if (!response.ok) {
    const errorText = await response.text()
    throw new Error(`Error al eliminar la membresía: ${errorText || "Sin detalles"}`)
  }
  return { success: true }
}
